import { birthYear, cpf, length, phone, phoneRequired, required } from '@polvo-labs/form-utils'
import Axios from 'axios'
import Autocomplete from '../../components/Form/Fields/Autocomplete'
import Avatar from '../../components/Form/Fields/Avatar'
import Select from '../../components/Form/Fields/Select'
import FieldType from '../../components/Form/Fields/type'
import { cpfCnpjValidation } from '../../utils/form-validations'

export interface AccountFormData {
  avatar: {
    id: number,
    url: string,
    small: string,
    large: string,
    medium: string,
    tiny: string,
    profession: string
  }
  name: string
  email: string
  city: string
  phone: string
  cpf: string
  birth_year: string
  profession: string
  gender: string
}

export type AccountForm = keyof AccountFormData

const fields: FieldType<AccountForm>[] = [
  {
    name: 'avatar',
    data: {},
    html: {},
    component: Avatar,
  },
  {
    name: 'name',
    data: {
      icon: 'text',
      label: 'Nome completo',
    },
    html: {
      maxLength: 100,
      placeholder: 'Nome e sobrenome',
    },
    validation: required,
  },
  // {
  //   name: 'city',
  //   component: Autocomplete,
  //   data: {
  //     icon: 'geolocation',
  //     label: 'Cidade atual',
  //     options: []
  //   },
  //   html: {
  //     maxLength: 30,
  //     placeholder: 'Onde você mora?',
  //   },
  //   validation: {
  //     validate: async (value: string, values: any) => {
  //       if (value && value.length >= 3) {
  //         const response = await Axios({
  //           method: 'GET',
  //           url: `${process.env.REACT_APP_API_URL}/cities/${value}/search`,
  //         })
  //         let exist = false
  //         response.data.data.forEach((element: any) => {
  //           if (element.city === value) {
  //             exist = true
  //           }
  //         })
  //         if (!exist)
  //           return 'Cidade inválida'
  //       }
  //     },
  //   },
  // },
  // {
  //   name: 'phone',
  //   data: {
  //     icon: 'phone',
  //     label: 'Telefone',
  //   },
  //   html: {
  //     maxLength: 15,
  //     placeholder: '(xx) xxxxx-xxxx',
  //   },
  //   validation: phone,
  // },
  {
    name: 'cpf',
    data: {
      icon: 'cpf',
      label: 'CPF',
    },
    html: {
      maxLength: 20,
      placeholder: 'Informe seu CPF',
      disabled: true,
    },
    validation: cpfCnpjValidation,
  },
  // {
  //   name: 'birth_year',
  //   data: {
  //     icon: 'calendar',
  //     label: 'Ano de nascimento',
  //   },
  //   html: {
  //     maxLength: 4,
  //     pattern: '\\d\\d\\d\\d',
  //     placeholder: 'Em que ano você nasceu?',
  //   },
  //   validation: birthYear,
  // },
  // {
  //   name: 'profession',
  //   data: {
  //     icon: 'profession',
  //     label: 'Profissão',
  //   },
  //   html: {
  //     maxLength: 100,
  //     placeholder: 'Qual a sua profissão?',
  //   },
  //   validation: length({ min: 1, max: 100 }),
  // },
  // {
  //   name: 'gender',
  //   component: Select,
  //   data: {
  //     label: 'Gênero',
  //     icon: 'gender',
  //     options: [
  //       {
  //         label: 'Informe seu gênero',
  //         value: '',
  //       },
  //       {
  //         label: 'Homem',
  //         value: 'MALE',
  //       },
  //       {
  //         label: 'Mulher',
  //         value: 'FEMALE',
  //       },
  //       {
  //         label: 'Outro',
  //         value: 'OTHER',
  //       },
  //     ],
  //   },
  //   html: {},
  // },
  {
    name: 'email',
    data: {
      icon: 'mail',
      label: 'E-mail',
    },
    html: {
      maxLength: 255,
      placeholder: 'nome@email.com',
      disabled: true,
    },
  },
]

export default fields
